<template>
<!-- barra_classe 4 passos ao cadastrar -->
  <div v-if="!ehCadastro()" class="barra_classe">
    <ol class="barra_classe_progress" data-steps="4">
      <li :class="situacao_um">
          <span class="nome_progress">1º Etapa</span>
          <span class="step_prograsso"><span class="span_posicao_barra">{{ posicao_um }}</span></span>
      </li>
      <li :class="situacao_dois">
          <span class="nome_progress">2º Etapa</span>
          <span class="step_prograsso"><span class="span_posicao_barra">{{ posicao_dois }}</span></span>
      </li>
      <li :class="situacao_tres">
          <span class="nome_progress">3° Etapa</span>
          <span class="step_prograsso"><span class="span_posicao_barra">{{ posicao_tres }}</span></span>
      </li>
      <li :class="situacao_quatro">
        <span class="nome_progress">4º Etapa</span>
        <span class="step_prograsso"><span class="span_posicao_barra">{{ posicao_quatro }}</span></span>
      </li>
    </ol>
  </div>

<!--  barra_classe 3 passos ao editar -->
  <div v-else class="barra_classe">
    <ol class="barra_classe_progress" data-steps="3">
      <li :class="situacao_um">
        <router-link :to="{ name: tipoDePessoa() }"
                      style="text-decoration: none">
          <span class="nome_progress">Dados Gerais</span>
          <span class="step_prograsso"><span class="span_posicao_barra">{{ posicao_um }}</span></span>
        </router-link>
      </li>
      <li :class="situacao_tres">
        <router-link :to="{ name: 'endereco_idEdita' }"
                     style="text-decoration: none">
          <span class="nome_progress">Endereço</span>
          <span class="step_prograsso"><span class="span_posicao_barra">{{ posicao_dois }}</span></span>
        </router-link>
      </li>
      <li :class="situacao_quatro">
        <router-link :to="{ name: 'documentos_idEdita' }"
                     style="text-decoration: none">
          <span class="nome_progress">Documentos</span>
          <span class="step_prograsso"><span class="span_posicao_barra">{{ posicao_tres }}</span></span>
        </router-link>
      </li>
    </ol>
  </div>

</template>

<script>

import caminhoGlobal from "@/router/caminho-global";

export default {
  name: "barra_classePassos",
  props: {
    id_passo: Number,
    nome_passo: Boolean,
    tipo_de_pessoa: String,
    posicao_um: String,
    posicao_dois: String,
    posicao_tres: String,
    posicao_quatro: String,
    posicao_cinco: String,
    situacao_um: String,
    situacao_dois: String,
    situacao_tres: String,
    situacao_quatro: String,
  },
  data() {
    return {
      rotas: new caminhoGlobal(),
    }
  },
  methods: {
    ehCadastro() {
      return (this.nome_passo === true);
    },
    tipoDePessoa() {
      return this.tipo_de_pessoa
    }
  },
  mounted() {
    this.ehCadastro()
  }
}
</script>